import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { FieldIconSubText } from '@johnlewispartnership/wtr-ingredients/dist/Forms';
import { LabeledControl } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/LabeledControl';
import { Radio } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Radio';
import { Typography } from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import styles from '../../CompetitionsForm.module.scss';
const QuestionAndAnswers = ({ form: { errors, register }, questionAndOptions }) => (React.createElement("div", { className: classNames(styles.spacerLarge, styles.sectionWrapper) },
    React.createElement("div", { className: styles.spacer },
        React.createElement(Typography, { id: "question", styleAs: "paragraph", element: "p" }, questionAndOptions === null || questionAndOptions === void 0 ? void 0 : questionAndOptions.question)), questionAndOptions === null || questionAndOptions === void 0 ? void 0 :
    questionAndOptions.options.map(option => (React.createElement("div", { className: classNames(styles.spacer, styles.radioGroupWrapper), key: `question-and-answer-option-${option}` },
        React.createElement(LabeledControl, { control: React.createElement(Radio, { ref: register({ required: 'Please select an answer from the available options' }), name: "answer", value: option }), label: option, boxed: true })))),
    errors.answer && React.createElement(FieldIconSubText, { id: "crosswordAnswer", text: errors.answer.message })));
QuestionAndAnswers.defaultProps = {
    questionAndOptions: null,
};
QuestionAndAnswers.propTypes = {
    form: propTypes.shape({
        errors: propTypes.shape({
            answer: propTypes.shape({ type: propTypes.string, message: propTypes.string }),
        }).isRequired,
        register: propTypes.func.isRequired,
    }).isRequired,
    questionAndOptions: propTypes.shape({
        question: propTypes.string,
        options: propTypes.arrayOf(propTypes.string),
    }),
};
export default QuestionAndAnswers;
//# sourceMappingURL=index.js.map